import Button, {
  Kind as ButtonKind,
  Size as ButtonSize,
} from 'components/Button';
import {
  Color as IconColor,
  Type as IconType,
  Size as IconSize,
} from 'components/Icon';
import { Style as TooltipStyle } from 'components/Tooltip';
import { getTestId, getClass } from 'helpers/components';
import React, { FunctionComponent, ReactElement, useMemo } from 'react';

export const componentName = 'toggle-is-public';

export const LOCALE_CLICK_TO_MAKE_PUBLIC_LABEL =
  'Private Report, click to make public';
export const LOCALE_CLICK_TO_MAKE_PRIVATE_LABEL =
  'Public Report, click to make private';

export const MODIFIER_CLASS_IS_PUBLIC = 'public';

export type Props = {
  disabled?: boolean;
  isPublic?: boolean;
  testId?: string;
  onClick?: (isPublic: boolean) => void;
};

const ToggleIsPublic: FunctionComponent<Props> = (props): ReactElement => {
  const { disabled, isPublic = false, testId, onClick } = props;

  const handleClickPublic = (): void => {
    if (onClick) onClick(false);
  };

  const handleClickPrivate = (): void => {
    if (onClick) onClick(true);
  };

  const rootTestId = useMemo(() => getTestId(componentName, testId), [testId]);
  const rootClass = useMemo(
    () =>
      getClass(componentName, {
        boolean: [{ state: isPublic, class: MODIFIER_CLASS_IS_PUBLIC }],
      }),
    [isPublic],
  );

  return (
    <div className={rootClass} data-testid={rootTestId}>
      {isPublic ? (
        <Button
          kind={ButtonKind.icon}
          iconType={IconType.public}
          iconColor={IconColor.secondary}
          iconSize={IconSize.small}
          size={ButtonSize.small}
          tooltip={LOCALE_CLICK_TO_MAKE_PRIVATE_LABEL}
          tooltipStyle={TooltipStyle.tertiary}
          tooltipShowArrow={false}
          disabled={disabled}
          onClick={handleClickPublic}
        />
      ) : (
        <Button
          kind={ButtonKind.icon}
          iconType={IconType.private}
          iconColor={IconColor.secondary}
          iconSize={IconSize.small}
          size={ButtonSize.small}
          tooltip={LOCALE_CLICK_TO_MAKE_PUBLIC_LABEL}
          tooltipStyle={TooltipStyle.tertiary}
          tooltipShowArrow={false}
          disabled={disabled}
          onClick={handleClickPrivate}
        />
      )}
    </div>
  );
};

export default ToggleIsPublic;
